import { Box, Button, Card, CardContent, Checkbox, FormControlLabel, Typography } from "@mui/material";
import Scrollbars from "rc-scrollbars";
import { useEffect, useState } from "react";


export default function CheckList({ list, onChange, onCancel}) {

    /** @type {[Array, Function]} */
    const [$list, setList] = useState([])

    useEffect(() => {
        if (list) {
            setList(list)
        }
    }, [list]);



    // Обработчик переключения чекбокса
  const handleToggle = (ind) => {
    let tmp = JSON.parse(JSON.stringify($list))
    tmp[ind].checked = !tmp[ind].checked
    setList(tmp)
  };

  const onSave = () => {
    onChange($list)
  }

  return (
    <div style={{ height: '100%' }}>
        <div style={{width: "100%", display: 'flex', flexDirection: "row", alignItems:"center", justifyContent: 'center'}}>
            <Typography variant="body1" sx={{fontWeight: "bold"}} >
                Необходимые действия с товаром
            </Typography>
        </div>
        <Scrollbars autoHide style={{ height: '90%' }}>
            {/* Контейнер для вертикального расположения карточек */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 1 }}>
            {$list.map((item, ind) => (
                <Card
                key={item.id}
                variant="outlined"
                sx={{
                    minWidth: 200,
                    borderRadius: 2,
                    boxShadow: 1,
                    transition: '0.2s',
                    '&:hover': { boxShadow: 3 }
                }}
                >
                    <CardContent sx={{ py: 1, px: 2, '&:last-child': { pb: 1 } }}>
                        <FormControlLabel
                            control={
                            <Checkbox
                                checked={item.checked}
                                onChange={() => handleToggle(ind)}
                            />
                            }
                            label={
                            <Typography variant="body1" component="span">
                                {item.serv}
                            </Typography>
                            }
                            sx={{
                            m: 0,
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'space-between', // чекбокс уходит вправо
                            flexDirection: 'row-reverse',    // меняем порядок, чтобы чекбокс был справа от текста
                            }}
                            labelPlacement="start"             // при row-reverse нужно указать start
                        />
                        {item.cancel && (
                            <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block', ml: 4, mt: -0.5 }}
                            >
                            требуется убрать
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            ))}
            </Box>
        </Scrollbars>
        <div style={{ height: "9%", display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between'}}>
            <Button variant="contained" onClick={onCancel} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#a6adac', width: "100px", borderRadius: "10px"}} >Отмена</Button>
            <Button variant="contained" onClick={onSave} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376', width: "100px", borderRadius: "10px"}}>Сохранить</Button>
        </div>
    </div>
  );
}
